import { canUseDOM } from 'exenv';

type SurveyCheckResponse = {
  /**
   * Whether the survey can be shown
   */
  validated: boolean;
  /**
   * The time in minutes until survey launches
   */
  surveyFrequencyMinutes?: number;
  /**
   * The node id of the survey
   */
  surveyNodeId?: string | null;
};

/**
 * Calls surveyCheck middleware to check if the survey can be shown
 */
export async function surveyCheck(): Promise<SurveyCheckResponse> {
  if (canUseDOM) {
    const response = await fetch('/surveys/check', {
      method: 'GET'
    });

    return await response.json();
  }
  return {
    validated: false
  };
}

/**
 * Calls setVisitsSurveyCookie middleware to update visits cookie
 */
export async function updateSurveyVisitCookie(): Promise<Response> {
  return fetch('/surveys/visits', {
    method: 'POST'
  });
}

/**
 * Calls setCompletedSurveyCookie middleware to set completion cookie to completed
 */
export async function updateSurveyCompletionCookie(): Promise<Response> {
  return fetch('/surveys/completed', {
    method: 'POST'
  });
}

/**
 * Calls setDeclinedSurveyCookie middleware to set completion cookie to declined
 */
export async function updateSurveyDeclinedCookie(): Promise<Response> {
  return fetch('/surveys/declined', {
    method: 'POST'
  });
}
